import { useUiPreference } from "../../hooks/useUiPreference.ts";

/**
 * What the prospect drawer shows about the company, besides the website (always
 * shown). Each person picks theirs in the drawer; that and open/closed are remembered.
 */
export const COMPANY_DETAIL_SECTIONS = [
  { key: "facts", label: "Key facts" },
  { key: "financials", label: "Financials" },
  { key: "technologies", label: "Technologies" },
  { key: "summary", label: "About" },
  { key: "job_ads", label: "Job ads" },
  { key: "registry_events", label: "Company events" },
] as const;

export type CompanyDetailSection = (typeof COMPANY_DETAIL_SECTIONS)[number]["key"];

const SECTION_KEYS: readonly string[] = COMPANY_DETAIL_SECTIONS.map((s) => s.key);

const DEFAULT_SECTIONS: CompanyDetailSection[] = ["facts", "financials", "technologies", "summary"];

function isSectionList(value: unknown): value is CompanyDetailSection[] {
  return Array.isArray(value) && value.every((v) => typeof v === "string" && SECTION_KEYS.includes(v));
}

/** The sections this person shows in the drawer. */
export function useCompanyDetailSections() {
  return useUiPreference<CompanyDetailSection[]>("prospects.drawer.details", DEFAULT_SECTIONS, isSectionList);
}

/** The sections this person keeps open, toggled from the drawer. */
export function useExpandedCompanyDetails() {
  return useUiPreference<CompanyDetailSection[]>("prospects.drawer.expanded", [], isSectionList);
}
